// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  /* outline:1px solid ;*/
}
maincontainer {
  background: #ffffff;
  background: linear-gradient(to bottom, #ffffff 0%, #e1e8ed 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e1e8ed',GradientType=0 );
  height: 100%;
  margin: 0;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.wrapper-1 {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.wrapper-2 {
  padding: 30px;
  text-align: center;
}
h1 {
  font-family: "Kaushan Script", cursive;
  font-size: 4em;
  letter-spacing: 3px;
  color: #5892ff;
  margin: 0;
  margin-bottom: 20px;
}
.wrapper-2 p {
  margin: 0;
  font-size: 1.3em;
  color: #aaa;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 1px;
}
.go-home {
  color: #fff;
  background: #5892ff;
  border: none;
  padding: 10px 50px;
  margin: 30px 0;
  border-radius: 30px;
  text-transform: capitalize;
  box-shadow: 0 10px 16px 1px rgba(174, 199, 251, 1);
}
.footer-like {
  margin-top: auto;
  background: #d7e6fe;
  padding: 6px;
  text-align: center;
}
.footer-like p {
  margin: 0;
  padding: 4px;
  color: #5892ff;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 1px;
}
.footer-like p a {
  text-decoration: none;
  color: #5892ff;
  font-weight: 600;
}

@media (min-width: 360px) {
  h1 {
    font-size: 4.5em;
  }
  .go-home {
    margin-bottom: 20px;
  }
}

@media (min-width: 600px) {
  .content {
    max-width: 1000px;
    margin: 0 auto;
  }
  .wrapper-1 {
    height: initial;
    max-width: 620px;
    margin: 0 auto;
    margin-top: 50px;
    box-shadow: 4px 8px 40px 8px rgba(88, 146, 255, 0.2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/attendant/FormForQRScan/thankyou.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gEAAgE;EAChE,mHAAmH;EACnH,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oDAAoD;EACtD;AACF","sourcesContent":["* {\r\n  box-sizing: border-box;\r\n  /* outline:1px solid ;*/\r\n}\r\nmaincontainer {\r\n  background: #ffffff;\r\n  background: linear-gradient(to bottom, #ffffff 0%, #e1e8ed 100%);\r\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e1e8ed',GradientType=0 );\r\n  height: 100%;\r\n  margin: 0;\r\n  background-repeat: no-repeat;\r\n  background-attachment: fixed;\r\n}\r\n\r\n.wrapper-1 {\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.wrapper-2 {\r\n  padding: 30px;\r\n  text-align: center;\r\n}\r\nh1 {\r\n  font-family: \"Kaushan Script\", cursive;\r\n  font-size: 4em;\r\n  letter-spacing: 3px;\r\n  color: #5892ff;\r\n  margin: 0;\r\n  margin-bottom: 20px;\r\n}\r\n.wrapper-2 p {\r\n  margin: 0;\r\n  font-size: 1.3em;\r\n  color: #aaa;\r\n  font-family: \"Source Sans Pro\", sans-serif;\r\n  letter-spacing: 1px;\r\n}\r\n.go-home {\r\n  color: #fff;\r\n  background: #5892ff;\r\n  border: none;\r\n  padding: 10px 50px;\r\n  margin: 30px 0;\r\n  border-radius: 30px;\r\n  text-transform: capitalize;\r\n  box-shadow: 0 10px 16px 1px rgba(174, 199, 251, 1);\r\n}\r\n.footer-like {\r\n  margin-top: auto;\r\n  background: #d7e6fe;\r\n  padding: 6px;\r\n  text-align: center;\r\n}\r\n.footer-like p {\r\n  margin: 0;\r\n  padding: 4px;\r\n  color: #5892ff;\r\n  font-family: \"Source Sans Pro\", sans-serif;\r\n  letter-spacing: 1px;\r\n}\r\n.footer-like p a {\r\n  text-decoration: none;\r\n  color: #5892ff;\r\n  font-weight: 600;\r\n}\r\n\r\n@media (min-width: 360px) {\r\n  h1 {\r\n    font-size: 4.5em;\r\n  }\r\n  .go-home {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .content {\r\n    max-width: 1000px;\r\n    margin: 0 auto;\r\n  }\r\n  .wrapper-1 {\r\n    height: initial;\r\n    max-width: 620px;\r\n    margin: 0 auto;\r\n    margin-top: 50px;\r\n    box-shadow: 4px 8px 40px 8px rgba(88, 146, 255, 0.2);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
